import { CustomToolbarItemModel } from '@syncfusion/ej2-pdfviewer';

export const Toolbar_NoAnnotation = {
  showTooltip: true,
  showText: true,
  toolbarItems: [
    // 'OpenOption',
    'UndoRedoTool',
    'PageNavigationTool',
    'MagnificationTool',
    'PanTool',
    'SelectionTool',
    'SubmitForm',
    'FreeTextAnnotationOption',
    'InkAnnotationOption',
    'ShapeAnnotationOption',
    'StampAnnotation',
    'SignatureOption',
    'SearchOption',
    {
      prefixIcon: 'e-icons e-transform-left',
      id: 'rotateAnticlockwise',
      tooltipText: 'Rotate Anticlockwise'
    } as CustomToolbarItemModel,
    {
      prefixIcon: 'e-icons e-transform-right',
      id: 'rotateClockwise',
      tooltipText: 'Rotate Clockwise'
    } as CustomToolbarItemModel,
    {
      text: 'Rotate All',
      id: 'rotateall',
      tooltipText: 'Rotate All'
    } as CustomToolbarItemModel
    // {
    //   prefixIcon: 'e-icons e-rename-2',
    //   id: 'toggleWhiteOut',
    //   tooltipText: 'WhiteOut'
    // } as CustomToolbarItemModel,
    // {
    //   prefixIcon: 'e-icons e-redact',
    //   id: 'toggleRedact',
    //   tooltipText: 'Redact'
    // } as CustomToolbarItemModel
  ],
  annotationToolbarItems: [
    'HighlightTool',
    'UnderlineTool',
    'StrikethroughTool',
    'ColorEditTool',
    'OpacityEditTool',
    'AnnotationDeleteTool',
    'StampAnnotationTool',
    'HandWrittenSignatureTool',
    'InkAnnotationTool',
    'ShapeTool',
    'CalibrateTool',
    'StrokeColorEditTool',
    'ThicknessEditTool',
    'FreeTextAnnotationTool',
    'FontFamilyAnnotationTool',
    'FontSizeAnnotationTool',
    'FontStylesAnnotationTool',
    'FontAlignAnnotationTool',
    'FontColorAnnotationTool',
    'CommentPanelTool'
  ]
};

export const Toolbar_Annotation = {
  showTooltip: true,
  showText: true,
  toolbarItems: [
    'CommentTool',
    'AnnotationEditTool',
    'UndoRedoTool',
    'PageNavigationTool',
    'MagnificationTool',
    'PanTool',
    'SelectionTool',
    'SubmitForm',
    'FreeTextAnnotationOption',
    'InkAnnotationOption',
    'ShapeAnnotationOption',
    'StampAnnotation',
    'SignatureOption',
    'SearchOption',
    {
      prefixIcon: 'e-icons e-transform-left',
      id: 'rotateAnticlockwise',
      tooltipText: 'Rotate Anticlockwise'
    } as CustomToolbarItemModel,
    {
      prefixIcon: 'e-icons e-transform-right',
      id: 'rotateClockwise',
      tooltipText: 'Rotate Clockwise'
    } as CustomToolbarItemModel,
    {
      text: 'Rotate All',
      id: 'rotateall',
      tooltipText: 'Rotate All'
    } as CustomToolbarItemModel,
    {
      prefixIcon: 'e-icons e-rename-2',
      id: 'toggleWhiteOut',
      tooltipText: 'Redaction'
    } as CustomToolbarItemModel
  ],
  annotationToolbarItems: [
    'HighlightTool',
    'UnderlineTool',
    'StrikethroughTool',
    'ColorEditTool',
    'OpacityEditTool',
    'AnnotationDeleteTool',
    'StampAnnotationTool',
    'HandWrittenSignatureTool',
    'InkAnnotationTool',
    'ShapeTool',
    'CalibrateTool',
    'StrokeColorEditTool',
    'ThicknessEditTool',
    'FreeTextAnnotationTool',
    'FontFamilyAnnotationTool',
    'FontSizeAnnotationTool',
    'FontStylesAnnotationTool',
    'FontAlignAnnotationTool',
    'FontColorAnnotationTool',
    'CommentPanelTool'
  ]
};

export const ToolbarSettings = {
  showTooltip: true,
  showText: true,
  toolbarItems: [
    'UndoRedoTool',
    'PageNavigationTool',
    'MagnificationTool',
    'PanTool',
    'SelectionTool',
    'SubmitForm',
    'FreeTextAnnotationOption',
    'InkAnnotationOption',
    'ShapeAnnotationOption',
    'StampAnnotation',
    'SignatureOption',
    'SearchOption',
    {
      prefixIcon: 'e-icons e-transform-left',
      id: 'rotateAnticlockwise',
      tooltipText: 'Rotate Anticlockwise'
    } as CustomToolbarItemModel,
    {
      prefixIcon: 'e-icons e-transform-right',
      id: 'rotateClockwise',
      tooltipText: 'Rotate Clockwise'
    } as CustomToolbarItemModel,
    {
      text: 'Rotate All',
      id: 'rotateall',
      tooltipText: 'Rotate All'
    } as CustomToolbarItemModel,
    {
      prefixIcon: 'e-icons e-rename-2',
      id: 'toggleWhiteOut',
      tooltipText: 'Redaction'
    } as CustomToolbarItemModel
  ],
  annotationToolbarItems: [
    'HighlightTool',
    'UnderlineTool',
    'StrikethroughTool',
    'ColorEditTool',
    'OpacityEditTool',
    'AnnotationDeleteTool',
    'StampAnnotationTool',
    'HandWrittenSignatureTool',
    'InkAnnotationTool',
    'ShapeTool',
    'CalibrateTool',
    'StrokeColorEditTool',
    'ThicknessEditTool',
    'FreeTextAnnotationTool',
    'FontFamilyAnnotationTool',
    'FontSizeAnnotationTool',
    'FontStylesAnnotationTool',
    'FontAlignAnnotationTool',
    'FontColorAnnotationTool',
    'CommentPanelTool'
  ]
};
